VLW.LesHommesEnfantPIXI = class extends VLW.classBase {
	constructor(o) {
		super();
		this.renderable      = true;
		this.uid             = guid();
		this.stage           = o.stage;
		this.maskCoordinate  = {to: {x: 0, y: 0}, current: {x: 0, y: 0}};
		this.cptRender       = 0;
		this.speed           = 0.025;
		this.scaleMaskRond   = {x: 1.25, y: 1.25};
		this._eltSelected    = "";
		this._maskFullScreen = false;
		this.resize          = debounce(this.resize, 50);
		broadCaster.MENU_HOVER.add(this.onMainMenuHover);
		broadCaster.MENU_LEAVE.add(this.onMainMenuLeave);
	}
	
	get eltSelected() {
		return this._eltSelected;
	}
	
	set eltSelected(code) {
		this._eltSelected = code;
		TweenMax.killTweensOf("._voileNoir");
		if (this._eltSelected !== "") {
			this.maskFullScreen = true;
			this.onMouseEnterElt(code);
			this.oSprite[this.eltSelected] && TweenMax.to(this.oSprite[this.eltSelected], .75, {pixi: {alpha: 1}, ease: Sine.easeOut});
		} else {
			TweenMax.to(Object.values(this.oSprite), 0, {pixi: {alpha: 0}, ease: Sine.easeOut});
		}
	}
	
	get maskFullScreen() {
		return this._maskFullScreen;
	}
	
	set maskFullScreen(full) {
		try {
			this._maskFullScreen = full;
			TweenMax.killTweensOf(this.containerMain2);
			if (this._maskFullScreen === true) {
				TweenMax.to(this.scaleMaskRond, 3, {x: 15, y: 8, ease: Power1.easeIn});
				this.maskGoToPosition(getDocSize().width * .5, getDocSize().height * .5);
			} else {
				TweenMax.to(this.sMask_rond, 1, {alpha: 1,});
				TweenMax.to(this.scaleMaskRond, 3, {x: 1.15, y: 1.30, ease: Power4.easeOut});
			}
		}catch (e) {
			console.log(e);
		}
	}
	
	set resources(resources) {
		let oOldFilmFilterMenuOn          = {
			sepia          : 0.7,
			noise          : 0,
			noiseSize      : 0,
			scratch        : 0,
			scratchDensity : 0,
			scratchWidth   : 0,
			vignetting     : .3,
			vignettingAlpha: 1,
			vignettingBlur : .5,
		};
		this.renderTexture                = PIXI.RenderTexture.create(getDocSize().width, getDocSize().height);
		this.containerMain                = new PIXI.Sprite();
		this.containerMainMenuHover       = new PIXI.Sprite(this.renderTexture);
		this.containerMain2               = new PIXI.Sprite(this.renderTexture);
		this.containerMain.name           = "LesHommesEnfant";
		this.containerMainMenuHover.name  = "LesHommesEnfant1";
		this.containerMain2.name          = "LesHommesEnfant2";
		this.containerMain2.alpha         = 0;
		this.containerMainMenuHover.alpha = 0;
		this.renderable                   = true;
		this.oSprite                      = {};
		this.cptZIndex                    = 1;
		this.sMask                        = new PIXI.Sprite();
		this.sMask_rond                   = new PIXI.Sprite(resources.mask.texture);
		this.sMask_rond.anchor.set(.5);
		this.sMask.addChild(this.sMask_rond,);
		this.renderTextureDisplacement = PIXI.RenderTexture.create(getDocSize().width, getDocSize().height);
		this.superS                    = new PIXI.Sprite(this.renderTextureDisplacement);
		for (let i in resources) {
			if (i === "mask") {
				continue;
			}
			let _sprite     = this.constructor.createSprite(resources[i].texture, i);
			_sprite.zIndex  = this.cptZIndex;
			_sprite.alpha   = 0;
			_sprite.size    = {width: _sprite.width, height: _sprite.height};
			this.oSprite[i] = _sprite;
			this.containerMain.addChild(_sprite);
		}
		this.maskGoToPosition(getDocSize().width * .5, getDocSize().height * .5);
		this.setFullScreen(...Object.values(this.oSprite));
		this.containerMain.mask = this.superS;
		this.size();
		this.containerMainMenuHover.filters = [new PIXI.filters.OldFilmFilter(oOldFilmFilterMenuOn)];
		this.stage.containerMain.addChild(this.containerMain2, this.containerMainMenuHover);
		
		PIXIAPP.aToRender.push(this);
	}
	
	onMainMenuHover() {
		if (this.eltSelected !== "") {
			TweenMax.to(this.containerMainMenuHover, 1, {alpha: 1});
		}
	}
	
	onCtrlOutro(){
		if (this.eltSelected !== "") {
			TweenMax.to(this.containerMain2			, 1, {alpha: 0});
			TweenMax.to(this.containerMainMenuHover	, 1, {alpha: 0});
		}
	}
	
	onMainMenuLeave() {
		if (this.eltSelected !== "") {
			TweenMax.to(this.containerMainMenuHover, 1, {alpha: 0});
		}
	}
	
	maskGoToPosition(x, y) {
		this.maskCoordinate.to.x = x;
		this.maskCoordinate.to.y = y;
	}
	
	onMouseMoveElt(ratioX, ratioY) {
		this.maskGoToPosition(getDocSize().width * ratioX, getDocSize().height * ratioY);
	}
	
	onMouseEnterElt(code) {
		this.cptZIndex++;
		if(this.oSprite[code]) {
			this.oSprite[code].zIndex = this.cptZIndex;
		}
		this.containerMain.children.sort((itemA, itemB) => itemA.zIndex - itemB.zIndex);
		TweenMax.to(this.containerMain2			, .75, {pixi: {alpha: 1, ease: Sine.easeOut}});
		TweenMax.to(Object.values(this.oSprite)	, .75, {pixi: {alpha: 0, ease: Sine.easeOut}});
		TweenMax.to(this.oSprite[code]	|| {}		, .75, {pixi: {alpha: 1, ease: Sine.easeOut}});
	}
	
	onMouseEnter() {
		TweenMax.to(this.stage.spriteHomeDisplacementMenu, .5, {pixi: {alpha: .5, ease: Sine.easeIn}});
		this.maskFullScreen = false;
	}
	
	onMouseLeave() {
		TweenMax.to(Object.values(this.oSprite), 1, {pixi: {alpha: 0}, ease: Sine.easeOut, delay: 0});
	}
	
	setFullScreen(...aElt) {
		aElt.forEach(elt => {
			let ratio  = Math.max((windowSize.width * 1) / elt.size.width, (windowSize.height * 1) / elt.size.height);
			elt.width  = Math.round(elt.size.width * ratio);
			elt.height = Math.round(elt.size.height * ratio);
		});
	}
	
	resize() {
		this.renderTextureDisplacement.resize(windowSize.width, windowSize.height);
		this.renderTexture.resize(windowSize.width, windowSize.height);
		this.superS.destroy();
		this.superS             = new PIXI.Sprite(this.renderTextureDisplacement);
		this.containerMain.mask = this.superS;
		this.setFullScreen(...Object.values(this.oSprite));
		this.size();
	}
	
	size() {
		let _aSize = [...Object.values(this.oSprite),];
		for (let i in _aSize) {
			_aSize[i].position.set(_aSize[i].width * .5, _aSize[i].height * .5);
		}
	}
	
	instanceClean() {
		window.removeEventListener("resize", this._debounceResize);
		broadCaster.MENU_HOVER.remove(this.onMainMenuHover);
		broadCaster.MENU_LEAVE.remove(this.onMainMenuLeave);
		
		this.stage.containerMain.removeChild(this.containerMain2);
		this.stage.containerMain.removeChild(this.containerMainMenuHover);
		this.sMask.removeChild(this.sMask_rond,);
		
		this.containerMainMenuHover.destroy();
		this.containerMain2.destroy();
		this.containerMain.destroy({children: true, texture: true, baseTexture: true});
		this.renderTextureDisplacement.destroy();
		this.renderTexture.destroy();
		this.sMask.destroy({children: true, texture: true, baseTexture: true});
		this.sMask_rond.destroy();
		this.superS.destroy({children: true, texture: true, baseTexture: true});
		super.instanceClean();
	}
	
	render() {
		PIXIAPP.app.renderer.render(this.sMask, this.renderTextureDisplacement);
		PIXIAPP.app.renderer.render(this.containerMain, this.renderTexture);
		this.maskCoordinate.current.x = this.maskCoordinate.current.x + (this.maskCoordinate.to.x - this.maskCoordinate.current.x) * this.speed;
		this.maskCoordinate.current.y = this.maskCoordinate.current.y + (this.maskCoordinate.to.y - this.maskCoordinate.current.y) * this.speed;
		if (this.maskFullScreen === false) {
			this.sMask_rond.rotation += 0.001;
			this.cptRender += .005;
		} else {
		}
		this.sMask_rond.scale.set(this.scaleMaskRond.x + Math.abs(Math.cos(this.cptRender)), this.scaleMaskRond.y + Math.abs(Math.cos(this.cptRender * 1.005)));
		this.sMask_rond.position.set(this.maskCoordinate.current.x, this.maskCoordinate.current.y);
		if (this.renderable === false) {
			return;
		}
	}
	
	static createSprite(texture = null, name = null) {
		let sprite = new PIXI.Sprite(texture);
		sprite.anchor.set(.5);
		sprite.name = name;
		return sprite;
	}
}